import Banner from '../components/Banner';
import TermsLogo from '../assets/images/terms-logo.svg';
import TermsOfUse from '../utils/TermsOfUse';

const TermsOfUseMain = () => {
  return (
    <div>
      <Banner bannerImage={TermsLogo} header="Terms of Use" />
      <div className="terms-of-use-main-page-layout">
        <TermsOfUse />
      </div>
    </div>
  );
};

export default TermsOfUseMain;
